<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-md-12">
            <div class="card-box">

                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.request.founded.trucker.title')}}</h4></h4>
                    </div>
                    
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>

                <br/>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter" class="btn btn-success w-30">{{$t('string.msg.form.btn.search')}}</button>
                          <download-excel v-if="items.length>0"
                                class   = "btn btn-primary"
                                :fetch   = "fetchData"
                                :fields = "json_fields"
                                :meta = "json_meta"
                                type    = "csv"
                                name    = "trucker-report.xls">
                                Download CSV
                            </download-excel>
                    </div>

              <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.company.label.name')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.main.email')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.primaryPhone')}}</th>
                            </tr>
                        </thead>
                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer">
                            <tr v-if="item.status == 'ACTIVE' && item.customerUser.status == 'ACTIVE'">
                                <td>
                                    <span>
                                        {{toUpperCase(item.firstName+' '+item.lastName)}}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{(item.email)}}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{(item.primaryPhone)}}
                                    </span>
                                </td>
                                 <td>
                                    <span v-if="item.customerUser && item.customerUser.cnhPhotoURL != 'https://semfoto' ">
                                        <img   v-bind:src="`${domain}${item.customerUser.cnhPhotoURL}`" alt="image" height="80" width="100">
                                    </span>
                                    <span v-else>
                                        {{$t('str.no.photo')}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>    
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Controller from './CrtWithoutVehicle';
export default {
  name: 'WithoutVehicle',
  props: ["valuekey"],
  watch:{
    'valuekey'(){},
  },
  components: {
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        json_fields: {
            'Nome': 'firstName',   
            'Sobrenome': 'lastName',
            'Email': 'email',
            'Telefone': 'primaryPhone',
        },
        json_data: [
            {
                firstName: null,
                lastName: null,
                email: null,
                primaryPhone: null,  
            },  
        ],
        json_meta: [
			[{
				"key": "charset",
				"value": "utf-8"
			}]
		],
      }
  },
  methods: Controller.methods,
  created() {
      Controller.init(this);

  },
  mounted(){
  }
}
</script>